/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { EventPlaceDTO } from './EventPlaceDTO';
import {
    EventPlaceDTOFromJSON,
    EventPlaceDTOFromJSONTyped,
    EventPlaceDTOToJSON,
    EventPlaceDTOToJSONTyped,
} from './EventPlaceDTO';

/**
 * 
 * @export
 * @interface EventDTO
 */
export interface EventDTO  {
    /**
     * 
     * @type {number}
     * @memberof EventDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof EventDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventDTO
     */
    eventName?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDTO
     */
    eventNumbering?: string;
    /**
     * 
     * @type {Date}
     * @memberof EventDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Array<EventPlaceDTO>}
     * @memberof EventDTO
     */
    eventPlaces?: Array<EventPlaceDTO>;
}

/**
 * Check if a given object implements the EventDTO interface.
 */
export function instanceOfEventDTO(value: object): value is EventDTO {
    return true;
}

export function EventDTOFromJSON(json: any): EventDTO {
    return EventDTOFromJSONTyped(json, false);
}

export function EventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
                  'eventName': json['eventName'] == null ? undefined : json['eventName'],
                  'eventNumbering': json['eventNumbering'] == null ? undefined : json['eventNumbering'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
              'eventPlaces': json['eventPlaces'] == null ? undefined : ((json['eventPlaces'] as Array<any>).map(EventPlaceDTOFromJSON)),
    };
}

export function EventDTOToJSON(json: any): EventDTO {
    return EventDTOToJSONTyped(json, false);
}

export function EventDTOToJSONTyped(value?: EventDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'endDate': value['endDate']?.toISOString(),
        'eventName': value['eventName'],
        'eventNumbering': value['eventNumbering'],
        'startDate': value['startDate']?.toISOString(),
        'eventPlaces': value['eventPlaces'] == null? value['eventPlaces']: (value['eventPlaces'] as Array<any>).map(EventPlaceDTOToJSON),
    };
}


